/*
  The calendar entries modal.

  Opens as soon as a sign-in hands back the calendars on the account. Kept
  separate from the Add / Edit Calendar modal deliberately: that one is about a
  credential, this one is about meeting rooms, and the table of entries needs
  far more room than a credential form does.

  EMMS has already saved the credential by then, so calendarCredentialId is
  set - see CalendarProvisioningStep, which does Import (create meeting rooms)
  and Map (update existing ones).
*/

import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CalendarProvisioningStep from "./CalendarProvisioningStep";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 1180,
  width: "96%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
  maxHeight: "92vh",
};

const CalendarEntriesModal = ({
  open,
  onClose,
  calendarCredentialId,
  credentialName,
  calendars,
  emmsId,
  emmsHeaders,
  requestConfig,
  onSaveCredential,
}) => (
  <Modal
    open={Boolean(open)}
    onClose={onClose}
    aria-labelledby="calendar-entries-title"
  >
    <Box sx={style}>
      <CalendarProvisioningStep
        calendarCredentialId={calendarCredentialId}
        credentialName={credentialName}
        calendars={calendars}
        emmsId={emmsId}
        emmsHeaders={emmsHeaders}
        requestConfig={requestConfig}
        onSaveCredential={onSaveCredential}
        onDone={onClose}
      />
    </Box>
  </Modal>
);

export default CalendarEntriesModal;
